/**
 * Pfadvergleiche für die App-Shells (Layout, LayoutMidwife): Welche Seiten sind
 * Hauptseiten mit Logo, welche Unterseiten mit Zurück-Pfeil?
 *
 * Ein abschließender Schrägstrich zählt nicht; vorher standen alle Pfade doppelt in
 * den Listen (`/user/tracking` und `/user/tracking/`).
 */

/** Entfernt einen abschließenden Schrägstrich, lässt die Wurzel "/" in Ruhe. */
export function normalizePath(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
}

/** Ist der Pfad genau einer der angegebenen (ohne Rücksicht auf den Schrägstrich am Ende)? */
export function isOneOfPaths(pathname: string, paths: readonly string[]): boolean {
  const current = normalizePath(pathname)
  return paths.some((path) => normalizePath(path) === current)
}

/** Liegt der Pfad unterhalb von `base` (z.B. `/user/tracking/` unter `/user/tracking`)? */
export function isUnderPath(pathname: string, base: string): boolean {
  return normalizePath(pathname).startsWith(`${normalizePath(base)}/`)
}

/**
 * Wohin ein `from`-Parameter zurückführt.
 *
 * Kapitel merken sich ihre Herkunft in der Adresse, damit der Zurück-Pfeil im Header
 * und der Pfeil nach unten in der Leseansicht am selben Ort landen wie die Liste, aus
 * der man kam. Steht hier nichts Bekanntes, gibt es kein Ziel.
 */
export function listRouteFor(from: string | null | undefined): string | null {
  switch (from) {
    case 'tracking':
      return '/user/tracking'
    case 'entdecken':
      return '/user/entdecken'
    case 'meineTitel':
      return '/user/meine-titel'
    default:
      return null
  }
}
